import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const insertCompanyEmpBranch = createAsyncThunk(
  "CompanyEmpBranch/insertCompanyEmpBranch",
  async (values, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/addCompanyEmpBranch`, values, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: "تم التعديل بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      }
      return rejectWithValue(error.message);
    }
  }
);
export const fetchCompanyEmpBranch = createAsyncThunk(
  "CompanyEmpBranch/CompanyEmpBranch",
  async (id, thunkAPI) => {
    const {rejectWithValue } = thunkAPI;

    try {
      const res = await axios.get(`${BaseUrl}/getBranchCompanyEmp/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;

      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      }
      return rejectWithValue(error.message);
    }
  }
);
const CompanyEmpBranchSlice = createSlice({
  name: "CompanyEmpBranch",
  initialState: {
    CompanyEmpBranch: [],
    CompanyEmpBranchID: [],
    loading: false,
    loadingAdd: false,
    error: null,
  },
  reducers: {
    clearCompanyEmpBranch: (state) => {
      state.CompanyEmpBranch = [];
      state.CompanyEmpBranchID = [];
      state.loading = false;
      state.loadingAdd = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loadingAdd = action.payload; // Set isLoading to the provided value 
    },
  },
  extraReducers: {
    //insert Branch Employee
    [insertCompanyEmpBranch.pending]: (state, action) => {
      state.loadingAdd = true;
      state.error = null;
    },
    [insertCompanyEmpBranch.fulfilled]: (state, action) => {
      state.CompanyEmpBranch.push(action.payload);
      state.loadingAdd = false;
    },
    [insertCompanyEmpBranch.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingAdd = false;
    },
    //Fetch Branch Employee By ID
    [fetchCompanyEmpBranch.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchCompanyEmpBranch.fulfilled]: (state, action) => {
      state.CompanyEmpBranchID = action.payload;
      state.loading = false;
    },
    [fetchCompanyEmpBranch.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearCompanyEmpBranch ,setLoading } = CompanyEmpBranchSlice.actions;
export default CompanyEmpBranchSlice.reducer;
